import padStart from 'lodash/padStart'

export function parseMilliseconds(milliseconds: number): [milliseconds: string, seconds: string, minutes: string] {
  const minutes = Math.trunc(milliseconds / 60000)
  milliseconds -= minutes * 60000

  const seconds = Math.trunc(milliseconds / 1000)
  milliseconds -= seconds * 1000

  milliseconds = Math.trunc(milliseconds)

  return [
    padStart(milliseconds.toString(), 3, '0'),
    padStart(seconds.toString(), 2, '0'),
    padStart(minutes.toString(), 2, '0'),
  ]
}
